import React, {useState, useRef, useEffect} from 'react';
import MTable from '../../Components/MTable/MTable';
import { getListProduk } from '../../Service/SalesService';
import Overlay from '../../Components/Overlay';
import { NumberFormat } from '../../Components/NumberFormat';
import { useSelector } from 'react-redux';
import { getStok } from '../../Service/SalesService';
import { handlerFormError } from '../../Utils/Utils';

const { $ } = window;
const MIReadyStock = () => {
    let { userInfo } = useSelector(state => state.auth);
    const mTableP = useRef();
    const [indent_warehouses, setIndentWarehouses] = useState([]);
    const [state, setState] = useState({
        processing: false,
        showProduct: false,
        opsiProduct: {
            itemname: '',
            itemno:'',
            price: 0,
            qty: 1,
            type: 'D',
            paketid:'',
            gudang:'',
            grade:"A"
        }
    });
    const onChangeWarehouse = (e) => {
        const whs = e.target.value;
        let qty_indent = e.target[e.target.selectedIndex].getAttribute("data-stock");
        let {itemname, itemno, price, uom, qty_ready, qty_display, gudang_display, gudang_ready, type, paketid} = state.opsiProduct;
        $('[name="inlineRadioOptions"]').prop('checked', false);
        setState({
            ...state,
            showProduct: true,
            processing: false,
            opsiProduct: {
                itemname,
                itemno,
                price,
                qty: qty_indent > 0? 1: 0,
                type,
                paketid,
                gudang_indent: whs,
                qty_indent,
                gudang_selected: whs,
                uom,
                qty_selected: qty_indent,
            }
        });
    }

    useEffect(() => console.log(indent_warehouses), [indent_warehouses]);

    const onChangeGrade = (e) => {
        let grade = e.target.value;
        //let {itemno, itemname, price, uom} = state.opsiProduct;
        let {itemname, itemno, price, uom} = state.opsiProduct;
        $('[name="inlineRadioOptions"]').prop('checked', false);
        
        let payload = {
            items : [
                {
                    ItemCode : itemno
                }
            ],
            Whs : [
                {
                    WhsCode : (userInfo.user_warehouse_stock.match(/[0-9]+/g) != null ? userInfo.user_warehouse_stock.match(/[0-9]+/g)[0] : '')
                }
            ],
            grade
        }
        setState({...state, processing: true})
        getStok(payload).then(res => {
            let indent_whs = [];
            let dataStok = res.data;
            dataStok = dataStok.reverse();
            let indent = 0;
            let gd_indent = '';
            let current_indent = 0;
            console.log(dataStok);
            for (const key in dataStok) {
                if(dataStok[key].Type == "Indent" && dataStok[key].OnHand > 0){
                    indent_whs.push(dataStok[key]);
                }
            }
            if(indent_whs.length){
                indent = indent_whs[0].OnHand;
                gd_indent = indent_whs[0].WhsCode;
            }
            setIndentWarehouses(indent_whs);


            setState({
                ...state,
                showProduct: true,
                processing: false,
                opsiProduct: {
                    itemname,
                    itemno,
                    price,
                    qty: indent-current_indent > 0 ?1:0,
                    uom,
                    type: "I",
                    paketid: '',
                    qty_indent: indent-current_indent,
                    gudang_indent: gd_indent,
                    gudang_selected:indent-current_indent > 0? gd_indent:"" ,
                    qty_selected: indent-current_indent > 0? indent-current_indent: 0,
                    grade
                }
            });

            
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
            setState({...state, processing: false})
        })
    }
    const onRadioChange = (e, gd, qty) => {
        const _opsiProduct = {...state.opsiProduct, type: e.target.value, gudang_selected: gd, qty_selected: qty, qty: 1 };
        if(e.target.value === "I"){
            _opsiProduct.gudang_selected = indent_warehouses[0].WhsCode
            _opsiProduct.qty_selected = indent_warehouses[0].OnHand
        }
        setState({...state, opsiProduct: _opsiProduct});
    }
    const onSelectProduct = item => () => {
        console.log('masuk');
        item.Grade="A";
        $('[name="inlineRadioOptions"]').prop('checked', false);
        let payload = {
            items : [
                {
                    ItemCode : item.ItemCode
                }
            ],
            Whs : [
                {
                    WhsCode : (userInfo.user_warehouse_stock.match(/[0-9]+/g) != null ? userInfo.user_warehouse_stock.match(/[0-9]+/g)[0] : '')
                }
            ]
        }
    
        setState({...state, processing: true})
        getStok(payload).then(res => {
            //console.log(res.data);
            let indent_whs = [];
            let dataStok = res.data;
            dataStok = dataStok.reverse();
            let indent = 0;
            let gd_indent = '';
            let current_indent = 0;

            for (const key in dataStok) {
                if(dataStok[key].Type == "Indent" && dataStok[key].OnHand > 0){
                    indent_whs.push(dataStok[key]);
                }
            }
            if(indent_whs.length){
                indent = indent_whs[0].OnHand;
                gd_indent = indent_whs[0].WhsCode;
                setIndentWarehouses(indent_whs);
            }


            setState({
                ...state,
                showProduct: true,
                processing: false,
                opsiProduct: {
                    itemname: item.ItemName,
                    itemno: item.ItemCode,
                    price: item.Price,
                    uom: item.BuyUnitMsr,
                    type: indent-current_indent > 0? 'I': '',
                    paketid: '',
                    qty_indent: indent-current_indent,
                    gudang_indent: gd_indent,
                    grade: "A"
                }
            });

            
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
            setState({...state, processing: false})
        })
    

        
    };
    const columns_product = [
        {
            id: 1, title: 'Item Description', field: 'ItemName', sortable: true,
            render: item => {
                return (
                    <a
                        onClick={onSelectProduct(item)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: '500'
                        }}
                    >
                        {item.ItemName}
                    </a>
                )
            }
        },
        { id: 2, title: 'Model', field: 'U_SOL_EX_MODEL', sortable: true },
        { 
            id: 3, title: 'Price/Unit', field: 'Price',
            render: item => {
                return NumberFormat(item.Price)
            }
        },

    ];
    const propsTableProduct = { columns: columns_product, getData: getListProduk, showIndex: true, order: 'ItemName', direction: 'desc', searchBarWidth:"9"};
    return(
        <div className="content-wrapper" style={{padding:"20px 30px"}}>
             <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-12">
                            <h2 className="title-breadcrum">MI Ready Stock</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card shadow mb-4">
                <div className="card-body">
                <Overlay display={state.loading} />
           
            <section className="content">
                <div className="row">
                    <div className="col-md-9">
                        <MTable ref={mTableP} {...propsTableProduct} />
                    </div>
                    <div className='col-md-3'>
                        <Overlay display={state.processing} />
                        <div className="card">
                            <div className="card-header card-header-product">Detail Product</div>
                            <div className="card-body" style={{ minHeight: 250 }}>
                                {!state.showProduct ?
                                    <div>
                                        <div className="row h-100 justify-content-center align-items-center">
                                            <i className="bi bi-x-circle-fill" style={{ fontSize: 50 }}></i>
                                        </div>
                                        <br />
                                        <p style={{ textAlign: 'center' }}>Product not found!  <br />Please Select Product</p>
                                    </div>
                                    :
                                    <div>
                                        <div className='row h-100 justify-content-center align-items-center'>
                                            <p className='title-choose-produk'>{state.opsiProduct.itemname} ({state.opsiProduct.itemno})</p>
                                            <>
                                                <div className='mb-3'>
                                                    {/*<p className='title-choose-produk'>Choose Grade (for <b>indent</b> items only):</p>
                                                    <p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_indent}</p>*/}
                                                    <label>Select Grade: </label>
                                                    <select className='form-control ps-0' onChange={onChangeGrade}>
                                                        <option value="A">Grade A</option>
                                                        <option value="B">Grade B</option>
                                                    </select>
                                                </div>
                                                <div className='col-sm-10 mb-3'>
                                                    {/*<p className='title-choose-produk'>Choose Grade (for <b>indent</b> items only):</p>
                                                    <p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_indent}</p>*/}
                                                    <label>Select Warehouse: </label>
                                                    <select className='form-control ps-0' onChange={(e)=> onChangeWarehouse(e)} disabled={(!indent_warehouses || indent_warehouses.length <=0)}>
                                                        {indent_warehouses.map(item => {
                                                            return (
                                                                <option value={item.WhsCode} data-stock={item.OnHand}>{item.WhsCode}</option>
                                                            )
                                                            
                                                        })}
                                                        {/* <option value='C'>Grade C</option> */}
                                                    </select>
                                                </div>
                                            </>
                                            <div className='col-sm-4'>
                                                <div className="form-check form-check-inline" style={{ textAlign: 'center', paddingLeft: 0, display: 'block' }}>
                                                    <input className="form-check-input radio-helper" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="I" checked={state.opsiProduct.type=="I"} onChange={(e)=> onRadioChange(e, state.opsiProduct.gudang_indent, state.opsiProduct.qty_indent)} disabled={state.opsiProduct.qty_indent<1}/><br/>
                                                    <label className="form-check-label" htmlFor="inlineRadio3">Indent</label>
                                                    <span className='angka-stock'>{state.opsiProduct.qty_indent > 0 ? state.opsiProduct.qty_indent: 0}</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
                </div>
            </div>

        </div>
       
    );
}

export default MIReadyStock;